
import { defineComponent, ref, getCurrentInstance, onActivated } from 'vue';
import Search from 'vant/lib/search';
import { sendLog } from '@/common/radar';
import { getQuery } from '@/common/utils';
import { checkSnack } from '@/common/seo';

export default defineComponent({
    components: {
        Search,
    },
    props: {
        isUserCollect: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const searchText = ref('');
        const showShare = ref(true);

        const handleBackClick = () => {
            sendLog({
                type: 'click',
                name: 'TOP_AREA',
                value: {
                    button_type: 'back',
                },
            });

            const { page_source } = getQuery();
            if (['topic', 'article'].includes(page_source)) {
                window.history.back();
                // 清空列表，防止下次再次进入页面但path改变时 discover页没刷新
                proxy.$store.commit('newDiscoverModule/clearNewDiscoverList');
            } else {
                proxy.$router.push({ path: '/foryou', query: { page_source: 'search' } });
            }
        };

        const handleShare = () => {
            sendLog({
                type: 'click',
                name: 'TOP_AREA',
                value: {
                    button_type: 'share',
                },
            });
            proxy.$bus.emit('copyToClipboard', `${window.location.href}?copyType=search`);
        };

        const handleSearch = () => {
            sendLog({
                type: 'click',
                name: 'TOP_AREA',
                value: {
                    button_type: 'research',
                },
            });
            proxy.$router.push({
                path: `/discover/${searchText.value}`,
                query: {
                    from_user: 'true',
                },
            });
            setTimeout(() => {
                // eslint-disable-next-line vue/require-explicit-emits
                ctx.emit('init');
            }, 0);
        };

        const { isSnack } = checkSnack();
        const handleFocus = () => {
            showShare.value = false;
        };
        const handleBlur = () => {
            showShare.value = true;
        };

        const handleKeyDown = () => {};

        onActivated(() => {
            searchText.value = (proxy?.$route?.params?.content || '').replace(/(-)/g, ' ');
        });

        return {
            searchText,
            showShare,
            isSnack,
            handleBackClick,
            handleShare,
            handleFocus,
            handleSearch,
            handleBlur,
            handleKeyDown,
        };
    },
});
